import React, { useCallback } from "react";
import { EntityCloseStage } from "@common/types/entity";
import { CLOSE_STAGE_LABEL } from "@components/pageHeader/filters/Tabs/CloseStageFilter/closeStage.constants";
import { Checkbox } from "@design-system/Checkbox/Checkbox";
import { BaseFilterProps } from "../../lib";
import styles from "../CommonFilterTab.module.scss";

const allCloseStages = Object.values(EntityCloseStage);

export const CloseStageFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const handleChange = useCallback(
        (stage: EntityCloseStage) => {
            if (filters.closeStage?.includes(stage)) {
                onChange({
                    closeStage: filters.closeStage.filter((s) => s !== stage),
                });
            } else {
                onChange({
                    closeStage: [...(filters.closeStage ?? []), stage],
                });
            }
        },
        [filters.closeStage, onChange],
    );

    return (
        <section className={styles.direction}>
            <header className={styles.header}>Stage</header>

            <Checkbox
                label="All"
                checked={!filters.closeStage || filters.closeStage.length === 0}
                onCheckedChange={() => onChange({ closeStage: undefined })}
            />
            {allCloseStages.map((stage) => (
                <Checkbox
                    key={stage}
                    label={CLOSE_STAGE_LABEL[stage]}
                    checked={filters.closeStage?.includes(stage) ?? false}
                    onCheckedChange={() => handleChange(stage)}
                />
            ))}
        </section>
    );
};
